import React from "react";
import { UnderlineSketch, SectionFrame } from "../kits/DesignKit";
import { useInsertName } from "./utils/helpers";

const ContactIntroSection = () => {
  const name = useInsertName();

  return (
    <SectionFrame className="space-y-28 pb-16 px-4 ">
    <div className="text-center space-y-12 font-mono">
      <h2>
        Sag Hallo,{" "}
        <span className="relative inline-block">
          {name} <span>:)</span>
          <span className="absolute left-0 -bottom-1 w-full h-2">
            <UnderlineSketch color="#AC8E66" />
          </span>
        </span>{" "}
        <br className="sm:hidden" /> und lass uns schnacken!
      </h2>
  
      <p><span className="font-mono w-max-[300px] text-xs" >      Ob Fragen zu Projekten oder einfach nur für ein Moin. <br />
      Authentisch. Echt. Einfach. </span>
  
      </p>
    </div>
  </SectionFrame>
  
  );
};

export default ContactIntroSection;
